
















import { ValidationObserver } from 'vee-validate'
import Vue from 'vue'
import { Component, Prop, Ref } from 'vue-property-decorator'
import vSelect from 'vue-select'

import GetawayRequiredFieldView
  from './GetawayRequiredFieldView.vue'

@Component({
  components: {
    GetawayRequiredFieldView,
    ValidationObserver,
    vSelect,
  },
})
export default class GetawayRequiredParamsView extends Vue {
  @Prop() readonly fields!: any

  @Ref('form') form!: any

  private model: Record<string, any> | null = null

  private updateModel(): void {
    const model: {[key: string]: any} = {}

    for (const key of Object.keys(this.fields)) {
      switch (this.fields[key].type) {
        case 'phone':
          model[key] = ''
          break
        case 'select':
          model[key] = null
          break
        case 'text':
          model[key] = ''
          break
        default:
          model[key] = null
      }
    }

    this.model = model
  }

  private async formFilling(): Promise<any> {
    const isValid = await this.form.validate()

    if (isValid) {
      this.$emit('form-filling', { ...this.model })
    } else {
      this.$emit('form-filling', null)
    }
  }

  public created(): void {
    this.updateModel()

    this.$watch('model', () => this.formFilling(), { deep: true })
  }
}
